/// <reference path="../../../../../../node_modules/@types/datatables.net-buttons/index.d.ts" />
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService } from "../../../../shared/message.service";
import { Alert, AlertType } from "../../../../shared/alert.model";
import { MessageType } from "../../../../shared/messageType";
import { getAlertMessage } from "../../../../shared/api-loaders";
import { SnfLegacyMigrationService } from "../../../services/snf-legacy-migration.service";
import { MigrationUser } from "../../../model/migration-user";
import { Select2Option } from "../../../../shared/select2-option";
import {
  IMultiSelectOption,
  IMultiSelectSettings,
  IMultiSelectTexts,
} from "ngx-bootstrap-multiselect";
import { ProfileSyncService } from "../../../services/profile-sync.service";
import { CustomerService } from "../../../../ect-feature/services/customer.service";
import { ParameterService } from "../../../../ect-feature/services/parameter.service";
import { forkJoin } from "rxjs";
import { NgForm } from "@angular/forms";
import {
  getMultiSelectSettings,
  getMultiSelectTexts,
} from "../../../../shared/DropdownHelper";
import { CascadeManager } from "../../../../shared/cascade-manager";
import { getDefaultDataTableDefinitionLocalProcessing } from "../../../../shared/DataTablesHelper";
import {
  TreeviewItem,
  TreeviewConfig,
  TreeItem,
} from "@laijuthomas/ngx-treeview";
import {
  RolesDisciplines,
  UserDetailOptionsRole,
} from "../../../../users/models/user-detail-options";
import { SecurityService } from "../../../../shared/security.service";
import { ModalService } from "../../../../shared/modal.service";
import { SngLegacyImportConfirmationDialogComponent } from "../sng-legacy-import-confirmation/sng-legacy-import-confirmation-dialog.component";
import { SnfLegacyImportData } from "../../../model/SnfLegacyImportData";

@Component({
  selector: "re-snf-legacy-list",
  templateUrl: "./snf-legacy-list.component.html",
  styleUrls: ["./snf-legacy-list.component.scss"],
  standalone: false,
})
export class SnfLegacyListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  unfilteredData: MigrationUser[];
  /** Corporate structure for the currently selected environment, loaded lazily on environmentChanged. */
  currentEnvironmentData: RolesDisciplines | null = null;
  /** Full corporate structure for all environments of this customer. Populated from Redis cache probe
   *  on customer select (cache hit) or from background warm (cache miss). null = background still in flight. */
  allCorporateData: any[] | null = null;
  isSnfLegacyImportUser: boolean;

  // Checkbox selection tracking
  selectedUsers: Set<string> = new Set();
  selectAll: boolean = true;

  ngOnDestroy(): void {
    // Remove checkbox event listeners
    $("#selectAllCheckbox").off("change");
    $("#resultsDataTable").off("change", ".user-checkbox");

    // Remove draw event listener
    this.dataTable.off("draw.dt");

    delete window["currentComponent"];
    this.dataTable.destroy();
  }

  alert: Alert;
  cascadeManager = new CascadeManager(this);
  numberOfErrors: number;
  errorPercentage: number;
  dataTable: DataTables.Api;
  isSecurityTemplatesCollapsed = false;
  isPhysicianFeatureEnabled = false;
  constructor(
    private messageService: MessageService,
    private router: Router,
    private customerService: CustomerService,
    private profileSyncService: ProfileSyncService,
    private snfLegacyMigrationService: SnfLegacyMigrationService,
    private securityService: SecurityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private parameterService: ParameterService
  ) {
    this.cascadeManager.defaultResetAction = () => {
      this.alert = null;
    };
    this.cascadeManager.addEvent({
      event: this.customerChanged,
      reset: () => {
        this.customers = [];
        this.customer = null;
        this.currentEnvironmentData = null;
        this.allCorporateData = null;
      },
    });
    this.cascadeManager.addEvent({
      event: this.environmentChanged,
      reset: () => {
        this.environments = [];
        this.environment = null;
      },
    });
    this.cascadeManager.addEvent({
      event: this.corporationChanged,
      reset: () => {
        this.corporations = [];
        this.corporation = null;
        this.securityTemplateOptions = [];
      },
    });
    this.cascadeManager.addEvent({
      event: this.facilityChanged,
      reset: () => {
        this.facilityOptions = [];
        this.facilities = null;
      },
    });
    this.cascadeManager.addEvent({
      event: this.templateChanged,
      reset: () => {
        // Keep only Corporate Templates and Physician Templates (if they exist)
        // Remove Facility Templates (which are added dynamically)
        const corporateTemplatesIndex = this.securityTemplateOptions?.findIndex(
          (x) => x.text === "Corporate Templates"
        );
        const physicianTemplatesIndex = this.securityTemplateOptions?.findIndex(
          (x) => x.text === "Physician Templates"
        );

        if (corporateTemplatesIndex !== -1) {
          // Keep Corporate Templates and Physician Templates, remove everything else
          const templatesToKeep = [
            this.securityTemplateOptions[corporateTemplatesIndex],
          ];
          if (physicianTemplatesIndex !== -1) {
            templatesToKeep.push(
              this.securityTemplateOptions[physicianTemplatesIndex]
            );
          }
          this.securityTemplateOptions = templatesToKeep;
        }
      },
    });
    this.cascadeManager.addEvent({
      event: null,
      reset: () => {
        this.unfilteredData = null;
      },
    });
  }
  back() {
    this.router.navigate([".."], { relativeTo: this.route });
  }

  templateChanged() {
    this.cascadeManager.resetDependencies(this.templateChanged);
  }
  ngAfterViewInit(): void {
    this.reset();
  }
  export() {}
  reset() {
    this.form.resetForm({});
    this.environments = [];
    this.corporations = [];
    this.facilityOptions = [];
    this.currentEnvironmentData = null;
    this.allCorporateData = null;
    this.securityTemplateOptions = [];
    this.results = null;
    this.unfilteredData = null;
    this.dataTable?.clear();
    this.dataTable?.draw();
    this.cascadeManager.runFirstEvent();
    this.calculateNumberOfErrors();

    // Reset checkbox selection state
    this.selectedUsers.clear();
    this.selectAll = true;

    (<HTMLInputElement>(
      $("#templatesTree .treeview-header .row-filter input")[0]
    )).value = "";
  }
  async ngOnInit() {
    if (await this.securityService.isAuthenticated()) {
      this.isSnfLegacyImportUser = await this.securityService
        .isSnfLegacyImportUser()
        .toPromise();
    }

    this.load();

    this.configDataTable();
  }

  enableDisableExportButton() {
    if (this.dataTable.page.info().recordsDisplay == 0)
      this.disableExportButton();
    else this.enableExportButton();
  }
  disableExportButton() {
    document
      .querySelector(".button-container .buttons-csv")
      .setAttribute("disabled", "true");
  }

  enableExportButton() {
    document
      .querySelector(".button-container .buttons-csv")
      .removeAttribute("disabled");
  }

  configDataTable() {
    window["currentComponent"] = this;
    const component = this;
    this.dataTable = getDefaultDataTableDefinitionLocalProcessing(
      "#resultsDataTable",
      {
        buttons: [
          {
            extend: "csv",
            text: "Export to CSV",
            className: "btn btn-primary",
          },
        ],
        columns: [
          {
            title: '<input type="checkbox" id="selectAllCheckbox" checked />',
            orderable: false,
            className: "select-checkbox text-center",
            render: (data: any, type: any, r: MigrationUser) => {
              const checked = component.selectedUsers.has(r.zionUserName)
                ? "checked"
                : "";
              return `<input type="checkbox" class="user-checkbox" data-zion-username="${r.zionUserName}" ${checked} />`;
            },
          },
          {
            title: "First Name",
            render: (data: any, type: any, r: MigrationUser) => {
              return `${r.firstName}`;
            },
          },
          {
            title: "Middle Initial",
            render: (data: any, type: any, r: MigrationUser) => {
              return `${r.middleInitial}`;
            },
          },
          {
            title: "Last Name",
            render: (data: any, type: any, r: MigrationUser) => {
              return `${r.lastName}`;
            },
          },
          {
            title: "EMail",
            render: (data: any, type: any, r: MigrationUser) => {
              return `${r.email ?? ""}`;
            },
          },
          {
            title: "Security Template",
            render: (data: any, type: any, r: MigrationUser) => {
              return `${r.templateName}`;
            },
          },
          {
            title: "User Type",
            render: (data: any, type: any, r: MigrationUser) => {
              return `${r.userType}`;
            },
          },
          {
            title: "Zion Name",
            render: (data: any, type: any, r: MigrationUser) => {
              return `${r.zionUserName}`;
            },
          },
          {
            title: "Change Password",
            render: (data: any, type: any, r: MigrationUser) => {
              if (r.encryptionMethod == 1) return "";
              else return "Password change required";
            },
          },
        ],
      }
    );

    new $.fn.dataTable["FixedHeader"](this.dataTable);
    this.dataTable.buttons().container().appendTo($(".button-container"));

    this.dataTable.on("search.dt", () => {
      this.enableDisableExportButton();
    });

    // Synchronize checkboxes after pagination, search, or any draw event
    this.dataTable.on("draw.dt", () => {
      this.syncCheckboxesAfterDraw();
    });

    // Initialize checkbox event listeners
    this.initializeCheckboxListeners();
  }

  private initializeCheckboxListeners(): void {
    const component = this;

    // Select All checkbox handler
    $(document).on("change", "#selectAllCheckbox", function () {
      component.selectAll = $(this).is(":checked");
      component.toggleAllCheckboxes(component.selectAll);
    });

    // Individual checkbox handler (using event delegation)
    $("#resultsDataTable").on("change", ".user-checkbox", function () {
      const checkbox = $(this);
      const zionUserName = checkbox.data("zion-username");

      if (checkbox.is(":checked")) {
        component.selectedUsers.add(zionUserName);
      } else {
        component.selectedUsers.delete(zionUserName);
        component.selectAll = false;
        $("#selectAllCheckbox").prop("checked", false);
      }

      // Check if all are selected
      if (
        component.results &&
        component.selectedUsers.size === component.results.length
      ) {
        component.selectAll = true;
        $("#selectAllCheckbox").prop("checked", true);
      }
    });
  }

  private toggleAllCheckboxes(checked: boolean): void {
    this.selectedUsers.clear();

    if (checked && this.results) {
      // Add all users to selected set
      this.results.forEach((user) => {
        if (user.zionUserName) {
          this.selectedUsers.add(user.zionUserName);
        }
      });
    }

    // Update all checkboxes in the table
    $(".user-checkbox").prop("checked", checked);
  }

  private initializeAllUsersAsSelected(): void {
    this.selectAll = true;
    this.selectedUsers.clear();
    if (this.results) {
      this.results.forEach((user) => {
        if (user.zionUserName) {
          this.selectedUsers.add(user.zionUserName);
        }
      });
    }
    // Update Select All checkbox state
    $("#selectAllCheckbox").prop("checked", true);
  }

  private syncCheckboxesAfterDraw(): void {
    const component = this;

    // Sync individual checkboxes with selectedUsers Set
    $(".user-checkbox").each(function () {
      const checkbox = $(this);
      const zionUserName = checkbox.data("zion-username");
      const isSelected = component.selectedUsers.has(zionUserName);
      checkbox.prop("checked", isSelected);
    });

    // Sync "Select All" checkbox based on visible rows
    this.updateSelectAllCheckboxState();
  }

  private updateSelectAllCheckboxState(): void {
    if (!this.results || this.results.length === 0) {
      this.selectAll = false;
      $("#selectAllCheckbox").prop("checked", false);
      return;
    }

    // Check if all users in the current results are selected
    const allSelected = this.results.every(
      (user) => user.zionUserName && this.selectedUsers.has(user.zionUserName)
    );

    this.selectAll = allSelected;
    $("#selectAllCheckbox").prop("checked", allSelected);
  }

  private async load() {
    this.showSpinner();

    //loading customers - environments will be populated from corporate structure API
    this.customerService.getCustomersByStack().subscribe(
      (customers) => {
        this.customers = customers.map((c) => {
          return {
            data: c.accountId,
            id: c.id.toString(),
            text: c.accountName,
          };
        });
        this.hideSpinner();
      },
      (error) => {
        this.hideSpinner();
        this.alert = getAlertMessage(error);
      }
    );
  }
  multiSelectSettings = getMultiSelectSettings();
  multiSelectSettingsTexts = getMultiSelectTexts();

  customer: number;
  environment: number;
  corporation: number;
  _facilities: number[];
  get facilities(): number[] {
    return this._facilities;
  }
  set facilities(value: number[]) {
    this._facilities = value;
    this.facilityChanged(value);
  }

  customers: Select2Option[] = [];
  environments: Select2Option[] = [];
  corporations: Select2Option[] = [];
  facilityOptions: IMultiSelectOption[] = [];
  securityTemplateOptions: TreeviewItem[];

  onlyErrors = false;
  results: MigrationUser[] = [];

  onlyErrorsChanged($event) {
    this.applyExtraFilter();
  }
  applyExtraFilter() {
    if (this.onlyErrors)
      this.results = this.unfilteredData.filter(
        (x) => x.hasErrors == this.onlyErrors
      );
    else this.results = this.unfilteredData;

    // Initialize all users as selected by default BEFORE drawing
    // This ensures checkboxes render with correct state
    this.initializeAllUsersAsSelected();

    this.dataTable.clear();
    this.dataTable.rows.add(this.results);
    this.dataTable.draw();
  }
  run() {
    this.alert = null;
    this.results = [];
    this.showSpinner();
    let securityTemplates: UserDetailOptionsRole[] =
      this.getCheckedSecurityTemplates();

    let environmentId = +this.corporations.firstOrDefault(
      (x) => +x.id == this.corporation
    ).data;
    this.snfLegacyMigrationService
      .getUsers(
        this.customer,
        environmentId,
        this.corporation,
        this.facilities,
        securityTemplates,
        false,
        this.isPhysicianFeatureEnabled
      )
      .subscribe(
        (x) => {
          this.unfilteredData = x;
          this.applyExtraFilter();
          this.calculateNumberOfErrors();
          this.hideSpinner();
          this.enableDisableExportButton();
        },
        (error) => {
          this.hideSpinner();
          this.alert = getAlertMessage(error);
        }
      );
  }
  getCheckedSecurityTemplates(): UserDetailOptionsRole[] {
    let ret = new Array<UserDetailOptionsRole>();
    for (let item of this.securityTemplateOptions) {
      for (let child of item.children) {
        if (child.checked) ret.push(<UserDetailOptionsRole>child.value);
      }
    }

    return ret;
  }

  private calculateNumberOfErrors() {
    let errorCount = 0;
    let results = this.unfilteredData;
    if (!results) return;

    results.forEach((x) => {
      if (x.hasErrors) errorCount++;
    });
    this.numberOfErrors = errorCount;
    this.errorPercentage = 0;
    if (results.length > 0) {
      this.errorPercentage = (errorCount / results.length) * 100;
    }
  }

  private showSpinner() {
    this.messageService.send(MessageType.ProcessingOn);
  }

  private hideSpinner() {
    this.messageService.send(MessageType.ProcessingOff);
  }
  customerChanged($event) {
    this.cascadeManager.resetDependencies(this.customerChanged);

    if (this.customer) {
      this.showSpinner();
      let crmId = this.customers.firstOrDefault(
        (x) => +x.id == this.customer
      ).data;

      // Step 1: fast Redis-only probe (~5ms) — no SNF calls, empty array on cache miss.
      this.customerService.getCorporateStructureByCrmId(crmId, true).subscribe(
        (cached) => {
          if (cached && cached.length > 0) {
            // CACHE HIT: populate environments directly from cached data, done in ~5ms.
            this.allCorporateData = cached;
            this.environments = [
              { id: '', text: 'Not Selected' },
              ...(cached as any[]).map<Select2Option>((c: any) => ({
                id: c.configId.toString(),
                text: c.configName,
              }))
            ];
            this.environment = null;
            this.currentEnvironmentData = null;
            this.cascadeManager.runNextDependendentEvent(this.customerChanged);
            this.hideSpinner();
          } else {
            // CACHE MISS: call slim /configurations for the dropdown (~200ms, DB-only),
            // then fire background warm that stores result into allCorporateData.
            this.customerService.getCustomerConfigurationsByCrmId(crmId).subscribe(
              (configs) => {
                this.allCorporateData = null;
                this.environments = [
                  { id: '', text: 'Not Selected' },
                  ...configs.map<Select2Option>((c) => ({
                    id: c.configId.toString(),
                    text: c.configName,
                  }))
                ];
                this.environment = null;
                this.currentEnvironmentData = null;
                this.cascadeManager.runNextDependendentEvent(this.customerChanged);
                this.hideSpinner();

                // Background cache-warming — non-blocking, captures result so environmentChanged
                // can skip the per-environment SNF call if background completes before env is selected.
                this.customerService.getCorporateStructureByCrmId(crmId, false).subscribe({
                  next: (data) => { this.allCorporateData = data as any; },
                  error: (err) => console.warn('Background corporate-structure cache warm failed:', err),
                });
              },
              (error) => {
                this.hideSpinner();
                this.alert = getAlertMessage(error);
              }
            );
          }
        },
        (error) => {
          this.hideSpinner();
          this.alert = getAlertMessage(error);
        }
      );
    } else {
      this.cascadeManager.runNextDependendentEvent(this.customerChanged);
    }
  }

  environmentChanged($event) {
    this.cascadeManager.resetDependencies(this.environmentChanged);

    if (this.environment) {
      this.showSpinner();

      const handleCorpsAndParams = (corporations: any[], parameters: any[]) => {
        this.corporations = [
          { id: '', text: 'Not Selected', data: null },
          ...corporations.map<Select2Option>((e) => ({
            data: e.environmentID,
            id: e.corporationID.toString(),
            text: e.corpName,
          }))
        ];
        this.corporation = null;

        this.isPhysicianFeatureEnabled = false;
        if (parameters && parameters.length > 0) {
          const physicianParam = parameters.find(
            (p) => p.key?.toLowerCase() === 'bp.idm.auth.physician.enabled'
          );
          if (physicianParam) {
            this.isPhysicianFeatureEnabled =
              physicianParam.value?.toLowerCase() === 'true';
          }
        }
      };

      if (this.allCorporateData) {
        // Full data already in memory (cache hit or background warm completed) — no SNF call needed.
        this.currentEnvironmentData = (this.allCorporateData as any[]).find(
          (x: any) => x.configId?.toString() === this.environment?.toString()
        ) ?? null;

        forkJoin({
          corporations: this.profileSyncService.getCorporations(this.environment),
          parameters: this.parameterService.getParametersByPartialKey(
            this.environment.toString(),
            'bp.idm.auth.physician.enabled',
            true
          ),
        }).subscribe(
          (result) => {
            handleCorpsAndParams(result.corporations, result.parameters);
            this.cascadeManager.runNextDependendentEvent(this.environmentChanged);
            this.hideSpinner();
          },
          (err) => {
            this.alert = getAlertMessage(err);
            this.hideSpinner();
          }
        );
      } else {
        // allCorporateData not ready (background still in flight or failed) — fetch single-env SNF call.
        forkJoin({
          corporations: this.profileSyncService.getCorporations(this.environment),
          corporateStructure: this.customerService.getCorporateStructureByConfigId(
            this.environment.toString()
          ),
          parameters: this.parameterService.getParametersByPartialKey(
            this.environment.toString(),
            'bp.idm.auth.physician.enabled',
            true
          ),
        }).subscribe(
          (result) => {
            this.currentEnvironmentData = result.corporateStructure as any;
            handleCorpsAndParams(result.corporations, result.parameters);
            this.cascadeManager.runNextDependendentEvent(this.environmentChanged);
            this.hideSpinner();
          },
          (err) => {
            this.alert = getAlertMessage(err);
            this.hideSpinner();
          }
        );
      }
    } else {
      this.cascadeManager.runNextDependendentEvent(this.environmentChanged);
    }
  }

  treeConfig: TreeviewConfig = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
    maxHeight: 200,
    hasDivider: false,
  };

  getCurrentEnvironment() {
    if (this.currentEnvironmentData == null) {
      console.error(`Environment ${this.environment} not found.`);
      return null;
    }
    return this.currentEnvironmentData;
  }
  corporationChanged($event) {
    this.cascadeManager.resetDependencies(this.corporationChanged);

    if (this.corporation) {
      this.showSpinner();

      var currentEnvironment = this.getCurrentEnvironment();
      if (currentEnvironment == null) return;

      this.facilityOptions = currentEnvironment.facilities.map((x) => {
        return { id: x.id, name: x.name };
      });
      let currentCorporation = this.corporations.firstOrDefault(
        (x) => +x.id == this.corporation
      );

      // Filter roles based on roleAppliesTo and specialUserTokenDesc
      // Corporate Templates: roleAppliesTo is "System Wide" and specialUserTokenDesc contains "SpecialUser:Corporate"
      const corporateRoles = currentEnvironment.roles.filter((role) => {
        const appliesTo = role.roleAppliesTo?.toLowerCase()?.trim();
        const specialToken = role.specialUserTokenDesc?.toLowerCase()?.trim();
        return (
          appliesTo === "system wide" &&
          specialToken &&
          specialToken.includes("specialuser:corporate")
        );
      });

      let corporateTemplates = corporateRoles.map<TreeItem>((x) => {
        return { text: x.name, value: x, checked: false, facilityId: 0 };
      });

      this.securityTemplateOptions = [
        new TreeviewItem({
          text: "Corporate Templates",
          value: 0,
          collapsed: false,
          checked: false,
          children: corporateTemplates,
        }),
      ];

      // Physician Templates: Only add if feature is enabled
      // roleAppliesTo is "System Wide" and specialUserTokenDesc contains "SpecialUser:Physician" or "SpecialUser:NPPA"
      if (this.isPhysicianFeatureEnabled) {
        const physicianRoles = currentEnvironment.roles.filter((role) => {
          const appliesTo = role.roleAppliesTo?.toLowerCase()?.trim();
          const specialToken = role.specialUserTokenDesc?.toLowerCase()?.trim();
          return (
            appliesTo === "system wide" &&
            specialToken &&
            (specialToken.includes("specialuser:physician") ||
              specialToken.includes("specialuser:nppa"))
          );
        });

        if (physicianRoles.length > 0) {
          const physicianTemplates = physicianRoles.map<TreeItem>((role) => {
            return {
              text: role.name,
              value: role,
              checked: false,
              facilityId: 0,
            };
          });

          this.securityTemplateOptions.push(
            new TreeviewItem({
              text: "Physician Templates",
              value: 1,
              collapsed: false,
              checked: false,
              children: physicianTemplates,
            })
          );
        }
      }
      this.hideSpinner();
      this.cascadeManager.runNextDependendentEvent(this.corporationChanged);
    } else {
      this.cascadeManager.runNextDependendentEvent(this.corporationChanged);
    }
  }

  facilityChanged($event) {
    if (this.facilities && this.facilities.length > 0) {
      var currentEnvironment = this.getCurrentEnvironment();
      if (currentEnvironment == null) return;

      this.cascadeManager.runNextDependendentEvent(this.facilityChanged);

      let facilityNode: TreeviewItem;
      // Find existing Facility Templates node or create a new one
      const facilityTemplatesIndex = this.securityTemplateOptions.findIndex(
        (x) => x.text === "Facility Templates"
      );

      if (facilityTemplatesIndex === -1) {
        // Create new Facility Templates node
        facilityNode = new TreeviewItem({
          checked: false,
          text: "Facility Templates",
          value: 2,
        });
        this.securityTemplateOptions.push(facilityNode);
      } else {
        // Use existing Facility Templates node
        facilityNode = this.securityTemplateOptions[facilityTemplatesIndex];
      }

      let selectedFacilities = currentEnvironment.facilities.filter(
        (x) => this.facilities.firstOrDefault((f) => f == x.id) != null
      );
      let currentFacilityTemplates = facilityNode.children || [];

      // Add System Wide facility templates (roleAppliesTo = "System Wide" and specialUserTokenDesc is null/empty)
      const systemWideFacilityRoles = currentEnvironment.roles.filter(
        (role) => {
          const appliesTo = role.roleAppliesTo?.toLowerCase()?.trim();
          const specialToken = role.specialUserTokenDesc?.trim();
          return (
            appliesTo === "system wide" &&
            (!specialToken || specialToken === "")
          );
        }
      );

      // Add system-wide facility templates
      for (let role of systemWideFacilityRoles) {
        if (
          currentFacilityTemplates.firstOrDefault(
            (x) => x.value.id == role.id
          ) == null
        ) {
          let item = new TreeviewItem({
            text: role.name,
            value: role,
            checked: false,
            collapsed: false,
          });
          item["data"] = 0; // System-wide, not tied to specific facility
          currentFacilityTemplates.push(item);
        }
      }

      // Add facility-specific templates
      for (let fac of selectedFacilities) {
        for (var i = 0; i < fac.roles.length; i++) {
          let template = fac.roles[i];
          if (
            currentFacilityTemplates.firstOrDefault(
              (x) => x.value.id == template.id
            ) == null
          ) {
            let item = new TreeviewItem({
              text: template.name,
              value: template,
              checked: false,
              collapsed: false,
            });
            item["data"] = fac.id;
            currentFacilityTemplates.push(item);
          }
        }
      }

      //lets removed templates from unselected facilities (keep system-wide templates with data = 0)
      let newArray = [];
      for (var i = 0; i < currentFacilityTemplates.length; i++) {
        let template = currentFacilityTemplates[i];
        let facilityId = template["data"];
        // Keep system-wide templates (facilityId = 0) or templates from selected facilities
        if (
          facilityId === 0 ||
          selectedFacilities.firstOrDefault((x) => x.id == facilityId) != null
        ) {
          newArray.push(template);
        }
      }

      facilityNode.children = newArray;
    } else {
      this.cascadeManager.resetDependencies(this.facilityChanged);
    }
  }

  @ViewChild("form")
  form: NgForm;

  async import() {
    // Calculate number of selected users (users to be imported)
    const selectedCount = this.selectedUsers.size;

    let dialog =
      this.modalService.create<SngLegacyImportConfirmationDialogComponent>(
        SngLegacyImportConfirmationDialogComponent
      );
    dialog.component.numberOfUsers = selectedCount;
    dialog.component.crmID = this.customers.firstOrDefault(
      (x) => +x.id == this.customer
    ).data;

    let result = await dialog.modalRef.result;
    if (result) {
      this.importUsers(
        dialog.component.domain,
        dialog.component.crmID,
        dialog.component.tempPassword
      );
    }
  }
  importUsers(domain: string, crmID: string, tempPassword: string) {
    this.showSpinner();
    let securityTemplates: UserDetailOptionsRole[] =
      this.getCheckedSecurityTemplates();
    let environmentId = +this.corporations.firstOrDefault(
      (x) => +x.id == this.corporation
    ).data;

    // Get list of deselected users (users NOT in selectedUsers set)
    const excludedUserNames: string[] = this.unfilteredData
      .filter((user) => !this.selectedUsers.has(user.zionUserName))
      .map((user) => user.zionUserName);

    let importLegacyUsers: SnfLegacyImportData = {
      configId: this.environment, //environment is bound to the configuration.id from /api/environment/configurations
      environmentId: environmentId,
      corpId: this.corporation,
      crmId: crmID,
      facilityIdList:
        this.facilities == null ? null : this.facilities.join(","),
      excludeTemplateIdList: securityTemplates?.map((x) => x.id).join(","),
      emailDomain: domain,
      tempPassword: tempPassword,
      environmentName: this.environments.firstOrDefault(
        (x) => +x.id == this.environment
      ).text,
      corporationName: this.corporations.firstOrDefault(
        (x) => +x.id == this.corporation
      ).text,
      includeSpecialUsers: false,
      includePhysicianNppaUsers: this.isPhysicianFeatureEnabled,
      excludedUserNames: excludedUserNames,
    };
    this.snfLegacyMigrationService.import(importLegacyUsers).subscribe(
      (x) => {
        this.hideSpinner();
        this.back();
      },
      (error) => {
        this.hideSpinner();
        this.alert = getAlertMessage(error);
      }
    );
  }
}
